export default "__VITE_ASSET__YCjNttfW__"